import { render, staticRenderFns } from "./FileData.vue?vue&type=template&id=0688ac3a&scoped=true&"
import script from "./FileData.vue?vue&type=script&lang=js&"
export * from "./FileData.vue?vue&type=script&lang=js&"
import style0 from "./FileData.vue?vue&type=style&index=0&id=0688ac3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0688ac3a",
  null
  
)

export default component.exports